
export default {
  methods: {
    israelPhone2e164(phoneNumber) {
      return phoneNumber?.toString().replace(/^((?:0?5)|(?:9725))(\d{8})$/, '+9725$2')
    }
  },
};
